<template>
    <div ref="messageCenterRef">
        <!-- 消息列表 -->
        <div class="message-center-content message-active-top w-100% mt-10px overflow-y-auto " ref="messageContainer"
            :style="{ height: (isKeyboardShow ? chatHeight + 60 : chatHeight) + 'px' || '75vh' }">
            <!-- 加载更多指示器 -->
            <div v-if="isLoadingMore" class="load-more-indicator flex justify-center items-center py-16px">
                <div class="loading-spinner mr-8px"></div>
                <span class="color-#fff text-14px">{{ $t("message.loading_more") }}</span>
            </div>

            <!-- 没有更多消息提示 -->
            <div v-else-if="hasMessages && !hasMoreMessages" class="no-more-indicator flex justify-center py-16px">
                <span class="color-#fff text-12px">{{ $t("message.noMoreMessages") }}</span>
            </div>


            <div @click="handlePreviewIntro"
                class="relative rounded-15px mb-20px p-10px pr-13px color-#EDF4FF text-14px leading-22px max-w-335px ai-message-content color-bg">
                <div class="intro-text-clamp">
                    <span class="color-#fff font-600 mr-5px">{{ t('message.introLabel') }}</span>{{ info?.creatorNotes ||
                        t('message.introNoYet') }}
                </div>
                <img src="@/assets/images/message/bottom.svg" class="w-10px h-5px absolute bottom-10px right-4px" />
            </div>

            <!-- 消息项 -->
            <div class="message-center-content-item" :data-message-id="message.id"
                v-for="(message, index) in currentMessages" :key="message.id"
                v-show="!(showEditPopup && editingMessage?.id === message.id)" v-memo="[
                    message.type,
                    message.thinking,
                    message.id,
                    message.content,
                    message.status,
                    message.translated,
                    message.translatedContent,
                    message.translatedLang,
                    message.image,
                    message.isGeneratingImage,
                    message.hasGeneratedImage,
                    message.isSuccessful,
                    message.imageProgress,
                    message.msgId,
                    message.state,
                    messagePopover.popoverStates.value[message.id],
                    messagePopover.popoverPositions.value[message.id],
                    messagePopover.popoverContainerRef.value,
                    thinkingState.expandedMap.value[message.id],
                    thinkingState.isUpdatingMap.value[message.id],
                    translateLoadingMap[message.id],
                    isReplying,
                    isContinue,
                    isAllTranslate,
                    showToastPopup,
                    getThinkingContent(message),
                    getMessageContent(message),
                    getImageProgress(message),
                    latestSentMessageId,
                    chatStore.latestSentMessageId,
                    chatStore.isTyping,
                    index === currentMessages.length - 1,
                    showEditPopup,
                    editingMessage?.id,
                    userStore.userInfo.role,
                    equipmentInformation,
                    isFirstGenerateImage,
                    isShowFree
                ]">
                <!-- AI消息 -->
                <teleport to="body">
                    <div v-if="messagePopover.popoverStates.value[message.id]" :ref="messagePopover.setPopoverRef"
                        class="rp-popover-container" :style="messagePopover.getPopoverStyle(message.id)">
                        <PopoverSelect :info="message" @copy="handleCopy" @delete="handleDelete(message)"
                            :messageLength="currentMessages.length - 1" :index="index" @report="handleReport"
                            @create="handleCreateImage(message, false)" @createVideo="handleCreateVideo(message, false)"
                            @translate="handleTranslate(message.content, message)" :isShowFreeSelect="isShowFree"
                            :isFrist="currentMessages.length === 1" :isImages="message.image"
                            :isVideo="message.video" />
                    </div>
                </teleport>
                <div v-if="message.type === 'ai'" class="ai-message items-start mb-24px relative"
                    v-longpress="{ handler: (ctx: any) => handleLongPress(message.id, ctx), disabled: isReplying }">
                    <div class="chatsage-content">
                        <div class="relative">
                            <div
                                class="rounded-15px p-10px color-#EDF4FF text-12px leading-22px max-w-335px ai-message-content">
                                <!-- 🔧 思考块（独立显示） -->
                                <div v-if="getThinkingContent(message)"
                                    class="thinking-block mb-8px italic p-8px pl-0! rounded-6px bg-rgba-128-128-128-0.1 border-l-3px border-l-#888 cursor-pointer transition-all thinking"
                                    :class="{ 'thinking-expanded': thinkingState.expandedMap.value[message.id] }"
                                    @click="toggleThinking(message.id)">
                                    <div class="flex items-center gap-6px mb-4px justify-between">
                                        <div class="flex items-center gap-6px">
                                            <div class="text-13px flex">💭
                                                <span v-if="!getMessageContent(message)">
                                                    {{ t('message.thinking') }}
                                                </span>
                                                <span v-else>
                                                    {{ t('message.think') }}
                                                </span>
                                                <div class="flex items-center gap-2px ml-4px"
                                                    v-if="!getMessageContent(message)">
                                                    <span class="animate-bounce-dot dot-1">.</span>
                                                    <span class="animate-bounce-dot dot-2">.</span>
                                                    <span class="animate-bounce-dot dot-3">.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <img src="@/assets/images/message/right.svg" alt="" class="w-10px h-10px"
                                            v-if="getMessageContent(message)"></img>
                                    </div>
                                    <div class="text-13px leading-18px overflow-hidden thinking-text-scroll"
                                        :class="{ 'is-updating': thinkingState.isUpdatingMap.value[message.id] }"
                                        :ref="(el: any) => setThinkingScrollRef(message.id, el)"
                                        v-if="!getMessageContent(message)">
                                        <div class="thinking-text-inner">{{ getThinkingContent(message) }}</div>
                                    </div>
                                    <div class="lh-18px text-ellipsis thinking-text-inner-content" v-else>{{
                                        getThinkingContent(message) }}</div>
                                </div>

                                <!-- 正常消息内容 -->
                                <div v-if="getMessageContent(message)" class="content-color">
                                    <div class="message-content-html-wrapper"
                                        :class="{ 'has-typing-indicator': index === currentMessages.length - 1 && chatStore.isTyping }">
                                        <div v-html="renderMarkdown(getMessageContent(message))"
                                            class="message-content-html">
                                        </div>
                                        <!-- 🔧 新增：在最后一条 AI 消息且正在打字时，显示打字动画，紧跟在文字后面 -->
                                        <span v-if="index === currentMessages.length - 1 && chatStore.isTyping"
                                            class="typing-indicator">
                                            <span class="animate-bounce-dot dot-1">.</span>
                                            <span class="animate-bounce-dot dot-2">.</span>
                                            <span class="animate-bounce-dot dot-3">.</span>
                                        </span>
                                    </div>
                                </div>
                                <!-- 如果既没有内容也不在打字，显示空状态 -->
                                <div v-else-if="!getThinkingContent(message)"
                                    class="py-15px px-10px color-#999 text-12px">
                                    <!-- 空状态，可以不显示任何内容 -->
                                </div>
                                <div class="" v-if="!isReplying">
                                    <div class="color-red flex pt-10px pb-2px items-center justify-between gap-10px reload-message-content"
                                        v-if="index > 0 && index === currentMessages.length - 1">
                                        <div class="flex items-center justify-center">
                                            <div @click="handleReloadMessage(message)"
                                                class="flex items-center justify-center mr-18px">
                                                <img src="@/assets/images/chat/chatRecord/reload.svg" alt=""
                                                    class="w-20px h-20px">
                                            </div>
                                            <div @click="handleEditMessage(message)"
                                                class="flex items-center justify-center">
                                                <img src="@/assets/images/message/edit_icon.svg" alt=""
                                                    class="w-20px h-20px">
                                            </div>
                                        </div>
                                        <div class="rounded-15px color-#fff text-14px px-10px pl-5px leading-22px  h-30px flex font-500 items-center ai-message-content-translate"
                                            @click="handleTranslate(message.content, message)"
                                            v-if="index === currentMessages.length - 1">
                                            <div class="w-20px h-20px flex items-center justify-center ">
                                                <div class="flex items-center justify-center">
                                                    <div v-if="translateLoadingMap[message.id]"
                                                        class="flex items-center justify-center">
                                                        <img src="@/assets/images/message/loading.webp" alt=""
                                                            class="w-full h-full animate-spin"></img>
                                                    </div>
                                                    <!--  -->
                                                    <div class="flex items-center justify-center" v-else>
                                                        <img src="@/assets/images/home/Translation_is.svg" alt=""
                                                            class="w-full h-full" v-if="message.translated">
                                                        <img src="@/assets/images/message/Translation.svg" alt=""
                                                            class="w-full h-full" v-else>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 翻译 -->
                                            <div :class="message.translated ? 'color-#31CA41' : 'color-#999'">
                                                {{ t('message.translate') }}
                                            </div>
                                            <div v-if="message.translated"
                                                class="text-12px font-500 mx-5px w-14px h-14px flex items-center justify-center"
                                                :class="{ 'heartbeat-animation': showToastPopup }">
                                                <img v-if="!isAllTranslate"
                                                    src="@/assets/images/message/notUnlocked.svg" class="w-full h-full"
                                                    @click.stop="handleIsAllTranslate" />
                                                <img v-else src="@/assets/images/message/locked.svg"
                                                    class="w-full h-full" @click.stop="handleIsAllTranslate" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <!-- 继续说按钮 -->
                    <div v-if="isContinue && index === currentMessages.length - 1"
                        class="w-24px h-24px absolute bottom-0 right-0" @click="handleContinueSpeaking()">
                        <img src="@/assets/images/message/next.svg" class="w-full h-full"></img>
                    </div>
                    <!-- 图片位置：点击生成后先展示骨架，socket 推图后再显示真实图片（只作用于正在生图的那条消息） -->
                    <div class="image-position" v-if="(message.isGeneratingImage || message.image || message.video)">
                        <!-- 🔧 优化：使用相对定位，让骨架屏和图片可以叠加 -->
                        <div class="image-container">
                            <!-- 图片：如果存在就渲染，但可能还在加载中 -->
                            <div v-if="!message.isSuccessful" @click.stop="handleCreateImage(message, true)"
                                class="h-160px images-error flex items-center relative flex-col">
                                <div class="mb-15px mt-35px">
                                    <img src="@/assets/images/message/try_again.svg" class="w-20px h-20px">
                                </div>
                                <div
                                    class="text-12px font-500 color-#000 rounded-20px px-10px py-5px bg-#fff cursor-pointer">
                                    {{ t('message.tryAgain') }}
                                </div>
                                <div
                                    class="absolute failed-message py-3px w-100% bottom-0 left-0 text-11px bg-#EF3E3E flex items-center justify-center">
                                    <div class="w-80%">
                                        {{ t('error.generateImageFailed') }}
                                    </div>
                                </div>

                            </div>
                            <div v-else class="h-100% w-100%">
                                <div v-if="message.video" class="image-loaded relative"
                                    @click="handlePreviewVideo(message)">
                                    <video :src="message.video" :poster="message.coverImage||message.image"
                                        class="w-full h-full object-cover"
                                        @loadedmetadata="(e: any) => onLoadedMetadata(e, message)"></video>
                                    <div
                                        class="absolute top-50% left-50% -translate-x-1/2 -translate-y-1/2 w-24px h-24px flex items-center justify-center">
                                        <img src="@/assets/images/chat/chatRecord/paly.svg" alt=""
                                            class="w-full h-full ">
                                    </div>
                                </div>
                                <div v-else-if="message.image" class="image-loaded"
                                    :class="{ 'image-hidden': message.isGeneratingImage }"
                                    @click="handlePreviewImage(message)">
                                    <AppImage :src="message.image" alt="avatar" width="100%" height="100%"
                                        :show-loading="true" :show-error="true" :lazy-load="false"
                                        :custom-loading="true" :custom-error="true"
                                        fallback="@/assets/images/home/sitemap.webp" fit="cover"
                                        @load="() => handleImageLoad(message)"
                                        @error="() => console.log('Image error:', message.image)" />
                                </div>
                                <!-- 骨架屏：图片不存在或正在生成中时显示，覆盖在图片上方 -->
                                <div v-if="(!message.image && !message.coverImage) || message.isGeneratingImage"
                                    class="skeleton-image skeleton-overlay">
                                    <div class="skeleton-loading">
                                        <div class="loading-spinner"></div>
                                        <div class="loading-percentage">
                                            {{ getImageProgress(message) }}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 🔧 使用 opacity 而不是 v-if，避免按钮区域突然出现导致"下沉"效果 -->
                    <div class="flex items-center justify-between mt-10px transition-opacity duration-200" :style="{
                        opacity: isReplying ? 0 : 1,
                        pointerEvents: isReplying ? 'none' : 'auto',
                        visibility: isReplying ? 'hidden' : 'visible'
                    }" v-if="currentMessages.length > 1">
                        <div class="flex items-center gap-10px" v-if="userStore.userInfo.role !== 7 && !isShowFree">

                            <!-- 生图 -->
                            <div v-if="(index === currentMessages.length - 1) && !message.hasGeneratedImage && !message.isGeneratingImage && !message.video && !message.image"
                                class="rawImage flex items-center justify-center cursor-pointer"
                                @click="handleCreateImage(message, !isFirstGenerateImage, index === currentMessages.length - 1)">
                                <img src="@/assets/images/home/photo.svg" class="w-20px h-20px"></img>
                                <div class="text-12px font-500 mx-5px">
                                    {{ t('message.create') }}
                                </div>
                                <div class="free" v-if="!isFirstGenerateImage">{{ t('message.free') }}</div>
                                <div class="msg-img-cost" v-else>
                                    <div class="flex-shrink-0 mb-5px w-6px h-10px mr-2px">
                                        <img src="@/assets/images/message/crystal.svg" class="w-full h-full"></img>
                                    </div>
                                    <div>
                                        {{ equipmentInformation?.config?.msgImgCost }}
                                    </div>
                                </div>
                            </div>
                            <!-- 生视频 -->
                            <div>
                                <div v-if="(index === currentMessages.length - 1) && !message.isGeneratingImage && !message.video"
                                    class="rawImage flex items-center justify-center cursor-pointer"
                                    @click="handleCreateVideo(message, !isFirstGenerateVideo, index === currentMessages.length - 1)">
                                    <img src="@/assets/images/chat/chatRecord/video.svg" class="w-20px h-20px"></img>
                                    <div class="text-12px font-500 mx-5px mt-2px">
                                        {{ t('message.video') }}
                                    </div>
                                    <!-- <div class="free" v-if="!isFirstGenerateVideo">Free</div> -->
                                    <div class="msg-img-cost">
                                        <div class="flex-shrink-0 mb-5px w-6px h-10px mr-2px">
                                            <img src="@/assets/images/message/crystal.svg" class="w-full h-full"></img>
                                        </div>
                                        <div>
                                            {{ equipmentInformation?.config?.videoCreatePrice }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <!-- 用户消息 -->
                <div v-else-if="message.type === 'user'" class="user-message flex items-start justify-end mb-24px"
                    v-longpress="{ handler: (ctx: any) => handleLongPress(message.id, ctx), disabled: isReplying }">
                    <div class="message-content text-right relative">

                        <div class="flex items-center justify-center">
                            <!-- 只在发送失败时显示继续按钮 -->
                            <div class="text-red-200 cursor-pointer w-20px h-20px flex-shrink-0 mr-10px"
                                @click="handleRetryMessage(message)" v-if="message.status === 'failed'">
                                <img src="@/assets/images/chat/chatRecord/try_again.svg" class="w-full h-full" />
                            </div>
                            <!-- 发送失败从新发送的loading -->
                            <!-- <div class="text-red-200 cursor-pointer w-20px h-20px flex-shrink-0 mr-10px"
                                @click="handleRetryMessage(message)" v-if="message.status === 'sending'">
                                <img src="@/assets/images/chat/chatRecord/loading.webp" class="w-full h-full animate-spin" />
                            </div> -->
                            <div class="message-bubble text-left bg-#ffffff rounded-15px px-16px py-12px color-#01031B text-16px leading-22px max-w-500px inline-block"
                                :class="{
                                    'opacity-70': message.status === 'sending',
                                    'border-2 border-red-400': message.status === 'failed',
                                }">
                                {{ message.content }}
                            </div>
                        </div>
                        <div class="timestamp color-#000 text-10px mt-4px">
                            <span v-if="message.status === 'sending'" class="ml-4px">{{ t('message.sending') }}</span>
                            <!-- <span v-if="message.status === 'failed'" class="ml-4px color-red"
                                @click="handleRetryMessage(message)">{{ $t("send_failed")
                                }}</span> -->
                        </div>

                        <div v-if="latestSentMessageId && latestSentMessageId === message.id"
                            class="heart-icon absolute top--37px right--13px cursor-pointer heart-animation"
                            @animationend="chatStore.clearLatestSentMessageId()">
                            <img src="@/assets/images/message/heart.svg" class="w-86px h-44px" />
                        </div>
                    </div>
                </div>

                <!-- 系统消息 -->
                <div v-else-if="message.type === 'system'" class="system-message flex justify-center mb-16px">
                    <div class="bg-#01031B opacity-50 rounded-12px px-12px py-6px color-#e5e5e5 text-12px">
                        {{ message.content }}
                    </div>
                </div>
                <!-- </template> -->
                <!-- </van-popover> -->
                <!-- 只在 AI 通过 socket 打字时显示底部占位 -->
            </div>
            <!-- 如果 AI 真实在回复中，显示打字动画 -->
            <div v-if="isLoading" class="typing-dots py-15px w-80px px-10px bg-#1a1e38">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <!-- 没有历史记录时的加载动画：仅在首次初始化且当前会话还没有任何消息时显示 -->
            <div v-if="!hasMessages && isInitializing" class="typing-dots py-15px w-80px px-10px bg-#1a1e38">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

        <!-- 回到底部按钮 -->
        <Transition name="fade">
            <div v-if="showScrollBottom" class="scroll-to-bottom" @click="scrollToBottomInstant">
                <div class="w-40px h-40px">
                    <img src="@/assets/images/message/down.webp" alt="" class="w-full h-full" />
                </div>
            </div>
        </Transition>

        <!-- 全屏预览弹窗 -->
        <IntroPreviewPopup v-model:show="showFullscreenPreview" :name="info?.name" :intro="info?.creatorNotes"
            :isShowFree="isShowFree" :info="info" />
        <!-- 思考弹窗 -->
        <ThinkPopup v-model:visible="showThinkPopup" :info="info" :thinkConetnt="getCurrentThinkingContent()" />
        <!-- 全屏图片预览 -->
        <FullscreenImagePreviewMesage v-model:show="showImagePreview" :images="previewImages"
            :start-position="previewStartPosition" :isShowSetAsBackdrop="isShowSetAsBackdrop"
            :isShowbackDrop="isShowbackDrop" />
        <!-- 全屏视频预览 -->
        <ChatFullscreenVideoPreview v-model:show="showVideoPreview" :videos="previewVideos"
            :poster="previewVideoPoster" />
        <!-- 首充弹窗 -->
        <FirstChargePopUp v-model:showPopup="showPopupFirstCharge" url="/" />
        <!-- 场景切换弹窗 -->
        <ChatSceneSelector v-model:show="showSwitchModelPopup" :sceneList="sceneList" @select="handleSwitchScene" />
        <!-- 翻译锁定提示弹窗 -->
        <ChatTosatCenter v-model:show="showToastPopup" :isAllTranslate="isAllTranslate" :message="t('message.pleaseUnlock')" />
        <!-- 自动翻译中组件 -->
        <ChatTosatTranslateLoading :state="chatStore.translateMessageLoading" />

        <!-- 编辑弹窗组件 -->
        <ChatEditPopup v-model:show="showEditPopup" :message="editingMessage" :name="info?.name" :avatar="info?.avatar"
            :default-avatar="digitalHumanAvatar" @save="handleSaveEdit" @cancel="handleCancelEdit" />
    </div>
</template>

<script setup lang="ts">
import { useBurialPointStore } from "@/stores/burialPoint";
import FullscreenImagePreviewMesage from "./ChatFullscreenImagePreviewMesage.vue";
import ChatFullscreenVideoPreview from "./ChatFullscreenVideoPreview.vue";
import IntroPreviewPopup from "./ChatIntroPreviewPopup.vue";
import { ref, nextTick, onMounted, onUnmounted, watch, computed } from "vue";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useChatStore } from "@/stores/chat";
import { MessageAPI } from "@/services/message";
import { useMarkdown } from "@/composables/useMarkdown";
import { useImageProgress } from "@/composables/useImageProgress";
import { useMessagePopover } from "@/composables/useMessagePopover";
import { useThinkingState } from "@/composables/useThinkingState";
import PopoverSelect from "./ChatPopoverSelect.vue";
import { showLoadingToast, showErrorToast, showSuccessToast, closeToast } from "@/utils/toast";
import AppImage from "@/components/display/AppImage.vue";
import { useDialog } from "@/composables/useDialog";
import { useLanguage } from "@/utils/language";
import { theme } from "@/styles/theme";
import { useUserStore } from "@/stores/user";
import ThinkPopup from "./ChatThinkPopup.vue";
import FirstChargePopUp from "@/views/home/com/FirstChargePopUp.vue";
import ChatSceneSelector from "./ChatSceneSelector.vue";
import ChatTosatCenter from "./ChatTosatCenter.vue";
import ChatTosatTranslateLoading from './ChatTosatTranslateLoading.vue'
import ChatEditPopup from "./ChatEditPopup.vue";
import { logEventSafe } from "@/plugins/firebase";

const router = useRouter();
const { t } = useI18n();
const dialog = useDialog();
const chatStore = useChatStore();
const messageCenterRef = ref<HTMLElement>();
const isShowWidth = ref(false);
const { renderMarkdown, extractThinking } = useMarkdown();
const { language } = useLanguage();
const userStore = useUserStore();
const latestSentMessageId = computed(() => chatStore.latestSentMessageId);
const burialPointStore = useBurialPointStore();
// 显示首充弹窗
const showPopupFirstCharge = ref(false);
// 全屏图片预览状态
const showImagePreview = ref(false);
const previewImages = ref<string[]>([]);
const previewStartPosition = ref(0);
const isShowSetAsBackdrop = ref(false);
const isShowbackDrop = ref(false);
// 全屏视频预览状态
const showVideoPreview = ref(false);
const previewVideos = ref<string[]>([]);
const previewVideoPoster = ref('');
const showToastPopup = ref(false);
// 是否显示切换模型弹窗
const showSwitchModelPopup = ref(false);
// 思考弹窗显示状态
const showThinkPopup = ref(false);
// 🔧 修复：记录当前点击弹窗的消息 ID
const currentThinkingMessageId = ref<string | null>(null);
// 每条消息单独的翻译加载状态
const translateLoadingMap = ref<Record<string, boolean>>({});
// 当前场景
const activeScene = ref<any>();
// 锁定加载中
const showToastTranslateLoading = computed(() => chatStore.translateMessageLoading)

// 🔧 使用 composables 管理状态
const imageProgress = useImageProgress();
const messagePopover = useMessagePopover();
const thinkingState = useThinkingState();

// 🔧 切换思考块展开/收起
const toggleThinking = (messageId: any) => {
    logEventSafe('chat_show_thinking')
    // 🔧 修复：保存当前点击的消息 ID，用于弹窗显示对应的 thinking 内容
    currentThinkingMessageId.value = messageId
    showThinkPopup.value = true;
    thinkingState.toggleExpanded(messageId);
};

// 🔧 修复：获取当前点击消息的 thinking 内容
const getCurrentThinkingContent = () => {
    if (!currentThinkingMessageId.value) return ''
    const message = currentMessages.value.find((m: any) => m.id === currentThinkingMessageId.value)
    return getThinkingContent(message)
};

// Thinking 文字滚动到最新内容（使用 composable 管理）
const setThinkingScrollRef = (messageId: string, el: any) => {
    thinkingState.setScrollRef(messageId, el);
};

// 🔧 新增：提取消息的思考内容
const getThinkingContent = (message: any) => {
    const rawContent = message?.translated ? (message?.translatedContent || message?.content) : message?.content;
    return extractThinking(rawContent).thinking;
};

// 🔧 新增：获取消息的正常内容（不含思考）
const getMessageContent = (message: any) => {
    const rawContent = message?.translated ? (message?.translatedContent || message?.content) : message?.content;
    return extractThinking(rawContent).content;
};

// 🔧 获取图片生成进度（使用 composable）
const getImageProgress = (message: any): number => {
    return imageProgress.getProgress(message);
};

const isFirstGenerateImage = computed(() => userStore.getIsFirstGenerateImage());
const isFirstGenerateVideo = computed(() => userStore.getIsFirstGenerateVideo());
// 是否显示继续按钮
const isContinue = computed(() => {
    return userStore.isCheckButton
});

// 回到底部按钮显示状态
const showScrollBottom = ref(false);

// 使用store中的数据和方法
const currentMessages = computed(() => chatStore.currentMessages);
const hasMessages = computed(() => chatStore.hasMessages);
const isLoading = computed(() => chatStore.isLoading);
const isLoadingMore = computed(() => chatStore.isLoadingMore);
const hasMoreMessages = computed(() => chatStore.hasMoreMessages);
const isInitializing = computed(() => chatStore.isInitializing);
const equipmentInformation = computed(() => userStore.getEquipmentInformation());
// 🔧 在 AI 正在加载回复或打字时，一律禁止输入
const isReplying = computed(
    () => chatStore.isTyping || chatStore.isLoading || isInitializing.value
);
// 防抖：继续按钮冷却
const isContinueCooldown = ref(false);
// 全屏预览状态
const showFullscreenPreview = ref(false);



// 编辑弹窗状态
const showEditPopup = ref(false);
const editingMessage = ref<any>(null);

// 使用 ResizeObserver 监听宽度变化
let resizeObserver: ResizeObserver | null = null;

// 组件props - 接收数字人信息
interface Props {
    showConfirmNamePopup?: boolean;
    info?: any;
    digitalHumanId?: any;
    digitalHumanName?: string;
    digitalHumanAvatar?: string;
    sceneList?: any[];
    getSceneList?: () => Promise<void>;
    getRecordId?: (id: string) => void;
    keyboardShow?: () => void;
    keyboardHide?: () => void;
    chatHeight?: any;
    isKeyboardShow?: boolean;
    handleIsAllTranslate?: () => void;
    isAllTranslate?: boolean;
    handleShowOpeningRemarksPopup?: () => void;
    handleShowReloadMessagePopup?: (message?: any) => void;
    isRecommendedReply?: boolean;
    isShowFree?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    showConfirmNamePopup: false,
    sceneList: () => [],
    digitalHumanId: "default",
    digitalHumanName: "AI Assistant",
    digitalHumanAvatar: "/assets/images/discover/dome.png",
    getRecordId: () => { },
    keyboardShow: () => { },
    keyboardHide: () => { },
    chatHeight: 500,
    isKeyboardShow: false,
    handleIsAllTranslate: () => { },
    isAllTranslate: false,
    handleShowOpeningRemarksPopup: () => { },
    handleShowReloadMessagePopup: (message?: any) => { },
    isRecommendedReply: false,
    isShowFree: false
});

// 定义 emits
const emit = defineEmits<{
    messageSent: []
    keyboardShow: []
    keyboardHide: []
    showOpeningRemarksPopup: []
}>();



const updateWidthState = () => {
    if (messageCenterRef.value) {
        const width = messageCenterRef.value.clientWidth;
        isShowWidth.value = width > 1200;
    }
};

// 复制消息（优先 Clipboard API，回退到 execCommand）
const handleCopy = async (message: any) => {
    const textToCopy = (message?.translated ? (message.translatedContent || message.content) : message?.content) || ''
    if (!textToCopy) {
        showErrorToast(t('message.copyFailed'))
        return
    }

    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(textToCopy)
        } else {
            const textarea = document.createElement('textarea')
            textarea.value = textToCopy
            textarea.setAttribute('readonly', '')
            textarea.style.position = 'fixed'
            textarea.style.top = '-9999px'
            textarea.style.left = '-9999px'
            document.body.appendChild(textarea)
            textarea.focus()
            textarea.select()
            textarea.setSelectionRange(0, textToCopy.length)
            const ok = document.execCommand('copy')
            document.body.removeChild(textarea)
            if (!ok) throw new Error('execCommand copy failed')
        }
        messagePopover.closePopover(message.id)
        showSuccessToast(t('message.copySuccess'))
    } catch (err) {
        console.error('复制失败', err)
        showErrorToast(t('message.copyFailed'))
    }
}

// 删除聊天记录
const handleDelete = async (message: any) => {
    messagePopover.closePopover(message.id);
    const confirm = await dialog.confirm({
        title: t('message.deleteConfirm'),
        message: t('message.deleteMessage'),
    });
    if (!confirm) {
        return;
    }
    showLoadingToast();
    try {
        // 调用API删除消息
        await MessageAPI.deleteChatRecords({
            Ids: [Number(message.id)],
        });

        // 从前端状态中删除消息
        chatStore.deleteMessage(message.id);
        chatStore.switchDigitalHumanLocal(props.info.id);
        showSuccessToast(t('message.deleteSuccess'));

        setTimeout(() => {
            scrollToBottomInstant()
        }, 100);
    } catch (error) {
        showErrorToast(error as string);
    } finally {
        closeToast();
    }
};

// 举报消息
const handleReport = (message: any) => {
    messagePopover.closePopover(message.id);
    props.getRecordId(message.id);
};

/**
 * 长按处理（使用 composable）
 */
const handleLongPress = (messageId: string, ctx?: any) => {
    const position = ctx?.point ? {
        clientX: ctx.point.clientX,
        clientY: ctx.point.clientY
    } : undefined;
    messagePopover.openPopover(messageId, position);
};

// 滚动到底部方法（带动画）
const scrollToBottom = async () => {
    // 等待DOM更新完成
    await nextTick();

    const container = messageContainer.value;
    if (container) {
        // 使用 setTimeout 确保在下一个事件循环中执行
        setTimeout(() => {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth'
            });
        }, 10);
    }
};

// 🔧 新增：立即滚动到底部（无动画，像微信那样）
const scrollToBottomInstant = async () => {
    const container = messageContainer.value;
    if (container) {
        // 立即定位到底部，不使用动画

        await nextTick();

        container.scrollTop = container.scrollHeight;
    }
};

/**
 * 滚动到指定消息的顶部
 */
const scrollToMessageTop = async (messageId: string) => {
    // 等待DOM更新完成
    await nextTick();

    const container = messageContainer.value;
    if (!container) return;

    // 查找消息元素
    const messageElement = container.querySelector(`[data-message-id="${messageId}"]`) as HTMLElement;
    if (!messageElement) return;

    // 使用 setTimeout 确保在下一个事件循环中执行
    setTimeout(() => {
        const messageTop = messageElement.offsetTop;
        // 滚动到消息顶部
        container.scrollTo({
            top: messageTop,
            behavior: 'smooth'
        });
    }, 10);
};

// 模板引用
const messageContainer = ref<HTMLElement>();
// 🔧 记录上一次的 isTyping 状态，用于检测打字完成
let previousIsTyping = false;

// 🔧 优化：合并消息变化监听（滚动 + 清理状态 + UI耗时监控）
watch(
    currentMessages,
    async (newMessages) => {
        // 开始记录UI渲染耗时
        const renderStart = performance.now();

        // 1. 清理不存在的消息的 popover 状态
        const currentMessageIds = new Set(newMessages.map(msg => msg.id));
        messagePopover.cleanupStates(currentMessageIds);

        // 2. 自动滚动到底部
        // 加载更多时不要自动滚到底
        if (isLoadingMore.value) return;

        const container = messageContainer.value;
        if (!container) return;

        // 检测是否刚完成打字（isTyping 从 true 变为 false）
        const justFinishedTyping = previousIsTyping && !chatStore.isTyping;
        previousIsTyping = chatStore.isTyping;

        // 如果刚完成打字，不触发滚动（避免底部占位消失导致的"下沉"效果）
        if (justFinishedTyping) return;

        // 如果正在打字，检查正在打字的那条消息的高度
        if (chatStore.isTyping) {
            const nodes = document.querySelectorAll('.message-center-content-item')
            const lastDom = nodes[nodes.length - 1] as HTMLElement;
            if (lastDom && lastDom.offsetHeight > (Number(props.chatHeight || 0) - 60)) {
                // 如果超过聊天高度，不继续自动滚动
                return;
            }
        }

        // 仅在接近底部时自动滚到底
        const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        const nearBottom = distanceFromBottom < 80;

        if (nearBottom && currentMessages.value.length > 1) {
            if (chatStore.isTyping) {
                await scrollToBottom();
            } else {
                await scrollToBottomInstant();
            }
        }

        // 记录UI渲染耗时
        const renderEnd = performance.now();
        const renderTime = Math.round(renderEnd - renderStart);
        try {
            window.dispatchEvent(new CustomEvent('performance-monitor', {
                detail: { type: 'ui-render', time: renderTime }
            }));
        } catch (e) { /* ignore in non-browser env */ }
    },
    { deep: true, immediate: true }
);

// 监听 thinking 内容变化，只在打字（更新）时滚动到最新位置
watch(
    () => currentMessages.value.map(m => ({ id: m.id, thinking: getThinkingContent(m) })),
    (newValues, oldValues) => {
        newValues.forEach((newVal) => {
            const oldVal = oldValues?.find(o => o.id === newVal.id);
            if (oldVal && newVal.thinking !== oldVal.thinking && newVal.thinking) {
                thinkingState.markAsUpdating(newVal.id);
            }
        });
    },
    { deep: true }
);

// 监听 messageCenterRef 的挂载
watch(
    messageCenterRef,
    (newVal) => {
        if (newVal) {
            // 初始化时检查一次宽度
            updateWidthState();

            // 创建 ResizeObserver 监听宽度变化
            resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const width = entry.contentRect.width;
                    isShowWidth.value = width > 1200;
                }
            });

            // 开始观察元素
            resizeObserver.observe(newVal);
        } else if (resizeObserver) {
            // 清理观察器
            resizeObserver.disconnect();
            resizeObserver = null;
        }
    },
    { immediate: true }
);

/**
 * 重试发送失败的消息
 */
const handleRetryMessage = async (message: any) => {


    if (isLoading.value) {
        return;
    }

    try {
        // 调用store中的重发方法
        await chatStore.resendMessage(message.id);

        // 滚动到底部
        await scrollToBottom();
    } catch (error) {
        console.error("重试发送消息失败:", error);
        //   showError(t("send_failed") || "发送失败，请重试");
    }
};

/**
 * 是否只有一条消息或者是最后一条消息
*/

const isOnlyOneMessage = ((isLast: any, allLength: any) => {
    if (allLength > 1) {
        return false
    } else {
        if (isLast) {
            return true
        }
    }
});

/**
 * 重新生成聊天记录功能
 */
const handleReloadMessage = (message: any) => {
    // 🔧 如果正在生图中，不允许重新生成回复消息
    if (message.isGeneratingImage) {
        showErrorToast(t('message.generatingImage'))
        return
    }
    logEventSafe('role_newreply_again_button_click')
    props.handleShowReloadMessagePopup(message)
}

/**
 * 编辑聊天记录功能
 */
const handleEditMessage = (message: any) => {
    // 埋点
    logEventSafe('newreply_edit_click')
    // 设置埋点状态
    burialPointStore.setIsEdit(true)
    // 设置输入框文字字数
    burialPointStore.setInputTextLength(message.content.length)
    editingMessage.value = message;
    showEditPopup.value = true;
}

// 保存编辑
const handleSaveEdit = async (content: string) => {
    if (!editingMessage.value?.id) {
        showErrorToast(t('message.saveFailed'));
        return;
    }
    // 获取输入框文字字数
    const inputTextLength = burialPointStore.getInputTextLength()
    if (content.length !== inputTextLength) {
        // 用户编辑输入中埋点
        logEventSafe('newreply_edit_input')
        burialPointStore.removeInputTextLength()
    }
    try {
        showLoadingToast(t('message.saving'));
        await MessageAPI.editRecordInfo({
            RecordId: Number(editingMessage.value?.id),
            content: content,
        });

        // 更新本地消息内容
        await chatStore.updateMessageContent(editingMessage.value.id, content);

        showSuccessToast(t('message.saved'));
        // 清除埋点状态
        burialPointStore.removeIsEdit()
        // 用户编辑输入保存发送埋点事件
        logEventSafe('newreply_edit_input_save')
        showEditPopup.value = false;
    } catch (error) {
        console.log(error, 'error');
        showErrorToast(t('message.saveFailed'));
    }
}

// 取消编辑
const handleCancelEdit = () => {
    // 清除埋点状态
    burialPointStore.removeIsEdit()
    // 发送埋点事件
    logEventSafe('newreply_edit_input_cancel')
    // editingMessage.value = null;
    nextTick()
    showEditPopup.value = false;
    scrollToBottomInstant()
}

// 上滑动加载更多
const handleScroll = async (event: Event) => {

    const container = event.target as HTMLElement;
    const scrollTop = container.scrollTop;


    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    // 检查是否滚动到顶部（留一些余量）
    if (
        scrollTop <= 50 &&
        hasMoreMessages.value &&
        !isLoadingMore.value
    ) {
        // 记住当前滚动位置和内容高度
        const currentScrollHeight = scrollHeight;

        const success = await chatStore.loadMoreMessages();
        if (success) {
            // 保持滚动位置，避免跳动
            await nextTick();
            const newScrollHeight = container.scrollHeight;
            const heightDiff = newScrollHeight - currentScrollHeight;
            container.scrollTop = heightDiff + 50; // 补偿滚动位置
        }
    }

    // 控制回到底部按钮的显示
    // 当用户向上滚动超过一定距离时显示按钮
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

    if (distanceFromBottom > 50 && props.isRecommendedReply) {
        if (!chatStore.isShowOpeningRemarksPopup) {
            chatStore.setIsShowOpeningRemarksPopup(true)
            props.handleShowOpeningRemarksPopup()
        }
    }

    if (distanceFromBottom > 200) {
        showScrollBottom.value = true;
    } else {
        showScrollBottom.value = false;
    }
};


/**
 * 全屏预览
 */
const handlePreviewIntro = () => {
    showFullscreenPreview.value = true;
};


/**
 * 翻译
 */
const handleTranslate = async (content: any, messageItem: any, isAutoTranslate: boolean = true) => {
    messagePopover.closePopover(messageItem.id);
    if (isAutoTranslate) {
        if (props.isAllTranslate) {

            if (messageItem.translated) {
                showToastPopup.value = true;
                setTimeout(() => {
                    showToastPopup.value = false;
                }, 1000);
                return
            } else {
            }
        }
    }

    // 🔧 修复：使用 msgId 而不是 id 来查找消息
    const msgId = messageItem?.msgId || messageItem?.id
    if (!messageItem || !msgId) {
        if (msgId) {
            translateLoadingMap.value[msgId] = false
        }
        return
    }

    // 保存 msgId，防止异步操作后 messageItem 引用变化
    translateLoadingMap.value[msgId] = true

    try {
        const targetLanguage = language.value

        // 已翻译 → 切回原文
        if (messageItem?.translated) {
            messageItem.translated = false
            translateLoadingMap.value[msgId] = false
            await chatStore.setMessageTranslated(msgId, false)
            // 在 return 之前清除 loading，避免响应式更新时 loading 残留
            // 切回原文后，滚动到消息顶部
            await scrollToMessageTop(messageItem.id || msgId)
            closeToast()
            return
        }

        // 未翻译但已有译文 → 直接切换
        // if (messageItem?.translatedContent) {
        //     messageItem.translated = true
        //     translateLoadingMap.value[msgId] = false
        //     await chatStore.setMessageTranslated(msgId, true)
        //     // 在 return 之前清除 loading，避免响应式更新时 loading 残留
        //     // 切换翻译后，滚动到消息顶部
        //     await scrollToMessageTop(messageItem.id || msgId)
        //     closeToast()
        //     return
        // }

        // 真正请求接口
        const res = await MessageAPI.translate({
            content,
            src: 'auto',
            to: targetLanguage,
        })
        translateLoadingMap.value[msgId] = false


        if (res?.data) {
            const translatedText = res.data
            await chatStore.updateMessageTranslation(
                msgId,
                translatedText,
                targetLanguage
            )

            // 🔧 修复：确保 messageItem 引用也更新，让 Vue 能检测到变化
            messageItem.translatedContent = translatedText
            messageItem.translated = true
            if (targetLanguage) {
                messageItem.translatedLang = targetLanguage
            }
            // 🔧 修复：等待 Vue 响应式更新和 DOM 渲染完成后再滚动
            await nextTick()
            // 再等待一小段时间，确保翻译内容完全渲染到 DOM
            await new Promise(resolve => setTimeout(resolve, 100))
            // 翻译完成后，滚动到消息顶部
            await scrollToMessageTop(messageItem.id || msgId)
        }
    } catch (error) {
        console.error('翻译失败:', error)
        showErrorToast(t('error.translationFailed'))
    } finally {
        // 确保 loading 被清除（兜底处理）
        if (msgId) translateLoadingMap.value[msgId] = false
    }
}

const handleCreateImage = async (messageItem: any, isFree: boolean, isFinally?: boolean) => {

    messagePopover.closePopover(messageItem.id);
    userStore.setIsFirstGenerateImage()
    if (!isFree) {
        if (![3, 4, 5].includes(userStore.userInfo.role)) {
            showPopupFirstCharge.value = true
            return
        }
    }
    // 🔧 如果这条消息不存在，忽略点击
    if (!messageItem) return
    // 🔧 如果这条消息正在生成图片或已经生成过图片，忽略点击
    if (!isFree) {
        if (messageItem.isGeneratingImage || messageItem.hasGeneratedImage) return
    }

    await nextTick()
    if (isFinally) {
        scrollToBottom();
    }

    // 🔧 标记这条消息已经生成过图片，按钮将消失
    messageItem.hasGeneratedImage = true
    messageItem.isGeneratingImage = true
    messageItem.isSuccessful = true

    // 初始化进度为 0 并启动定时器
    imageProgress.initProgress(messageItem, 10000);

    try {
        await chatStore.generateImageFromMessage({

            recordId: Number(messageItem.msgId || messageItem.id),
            type: 1
        })
        // 历史回复创建图片埋点
        if (!isFinally) {
            logEventSafe('history_reply_create_img_click')
        }
    } catch (error) {
        if (!isFinally) {
            logEventSafe('history_reply_create_img_failed')
        }
        showErrorToast(t('message.imageFailed'))
        // 触发失败时清除这条消息的生图标记和进度
        messageItem.isGeneratingImage = false
        messageItem.hasGeneratedImage = false
        imageProgress.resetProgress(messageItem);
    }
}

const handleCreateVideo = async (messageItem: any, isFree: boolean, isFinally: boolean = true) => {
    messagePopover.closePopover(messageItem.id);
    userStore.setIsFirstGenerateVideo()
    if (!isFree) {
        if (![4, 5].includes(userStore.userInfo.role)) {
            if (equipmentInformation?.value?.config?.msgVideoCountDay > 1) {
                router.push({
                    path: 'vip',
                    query: {
                        type: 'u'
                    }
                })
                userStore.loginTouristFunc()
                return
            }
        }
    }

    await nextTick()
    if (isFinally) {
        scrollToBottom();
    }

    // 🔧 标记这条消息已经生成过图片，按钮将消失
    // messageItem.image = null
    messageItem.hasGeneratedImage = true
    messageItem.isGeneratingImage = true
    messageItem.isSuccessful = true

    imageProgress.initProgress(messageItem, 10000);

    try {
        await chatStore.generateImageFromMessage({

            recordId: Number(messageItem.msgId || messageItem.id),
            type: 2
        }, true)
    } catch (error) {
        console.log(error);

        showErrorToast(t('message.imageFailed'))
        // 触发失败时清除这条消息的生图标记和进度
        messageItem.isGeneratingImage = false
        messageItem.hasGeneratedImage = false
        imageProgress.resetProgress(messageItem);
    }

}
/**
 * AI 继续说（发送新消息，不显示用户的"继续"消息）
 */
const handleContinueSpeaking = async () => {
    if (isContinueCooldown.value) {
        return;
    }
    isContinueCooldown.value = true;
    // 调用 store 中的方法让 AI 继续对话（不显示用户消息）
    let success = false;
    try {
        success = await chatStore.continueAIReply(true);
    } finally {
        // 冷却 800ms，防止短时间多次点击
        setTimeout(() => {
            isContinueCooldown.value = false;
        }, 1500);
    }

    if (success) {
        // 滚动到底部以便看到新消息
        await scrollToBottom();
    } else {
        console.warn('⚠️ AI 继续对话失败');
    }
};

const handlePreviewImage = (message: any) => {
    previewImages.value = [message.image];
    previewStartPosition.value = 0;
    showImagePreview.value = true;
    isShowSetAsBackdrop.value = false;
    isShowbackDrop.value = false;
}

const handlePreviewVideo = (message: any) => {
    console.log(message);
    
    previewVideos.value = [message.video];
    previewVideoPoster.value = message.image || message.coverImage || '';
    showVideoPreview.value = true;
}
/**
 * 插入星号符号（用于特殊格式输入）
 */
/**
 * 🔧 处理图片加载完成事件
 * 当图片真正加载完成后，才清除生图标记，避免骨架屏消失后出现空白
 */
const handleImageLoad = (message: any) => {
    if (!message) return

    // 图片加载完成，清除生图标记
    nextTick(() => {
        message.isGeneratingImage = false
    })

    // 完成进度并自动重置
    imageProgress.completeProgress(message);
}

const onLoadedMetadata = (e: any, message: any) => {
    if (!message) return

    // 图片加载完成，清除生图标记
    nextTick(() => {
        message.isGeneratingImage = false
    })

    // 完成进度并自动重置
    imageProgress.completeProgress(message);
}

/**
 * 切换场景
 */
const handleSwitchScene = async (item: any, index: number) => {
    if (isReplying.value) return;
    if (![4, 5].includes(userStore.userInfo.role)) {
        router.push({ name: 'Vip', query: { type: 'u' } })
        return
    }
    activeScene.value = index;
    try {
        showLoadingToast(t('message.switchingScene'));
        // 调用切换场景接口
        const res = await MessageAPI.switchRoleScene({
            sceneId: item.id,
            roleId: item?.roleId,
        });

        // 切换成功后，重新加载聊天记录
        if (res && chatStore.currentDigitalHumanId) {
            // 使用 refreshDigitalHuman 方法刷新数字人数据和聊天记录
            await chatStore.refreshDigitalHuman(chatStore.currentDigitalHumanId);
            await props.getSceneList?.();

            // 关闭弹窗
            showSwitchModelPopup.value = false;

            // 滚动到底部
            await nextTick();
            scrollToBottom();

            showSuccessToast(t('message.switchSceneSuccess'));
        }
    } catch (error) {
        console.error('切换场景失败:', error);
        showErrorToast(t('message.switchSceneFailed'));
    } finally {
        // closeToast();
    }
}

// 组件挂载后滚动到底部
onMounted(async () => {

    // 等待组件完全挂载
    await nextTick();

    if (currentMessages.value.length > 1) {
        scrollToBottomInstant();
        setTimeout(() => {
            scrollToBottom();
        }, 500);
    }

    await chatStore.switchDigitalHumanLocal(props.digitalHumanId, props.digitalHumanName, props.digitalHumanAvatar);

    // 🔧 新增：检查并清理过期的等待回复状态
    // 场景：发送消息后立即退出 App，AI 在后台回复完成，重新进入时状态还在
    await chatStore.checkAndClearExpiredStates(props.digitalHumanId)

    // 进入页面后尝试恢复未完成的流式回复（刷新/返回后继续打字）
    // 仅在有 pendingReply 或 waitingReplies 时才尝试恢复
    try {
        const hasPendingReply = !!chatStore.pendingReply
        const hasWaitingReplies = chatStore.currentDigitalHumanId
            ? chatStore.hasWaitingReplies(chatStore.currentDigitalHumanId)
            : false

        // 只有在真正有等待状态时才尝试恢复，避免误触发
        if (hasPendingReply || hasWaitingReplies) {
            const recovered = await chatStore.checkAndRecoverState?.()
            if (!recovered && chatStore.resumeAIReplyForLastMessage) {
                // 若无需状态恢复，再尝试仅恢复流（不重复插入用户消息）
                await chatStore.resumeAIReplyForLastMessage()
            }
        }
    } catch (e) { }

    // 🔧 优化：使用 nextTick 等待 DOM 渲染完成后立即定位到底部（无动画）
    await nextTick();


    // IndexedDB 中的译文已由 store 覆盖，无需组件层缓存

    // 添加滚动监听
    if (messageContainer.value) {
        messageContainer.value.addEventListener("scroll", handleScroll);
    }

    // 监听全局点击/触摸以关闭 Popover
    messagePopover.registerGlobalListeners();


});

// 🔧 新增：监听消息加载完成后自动翻译（异步）
watch(
    () => currentMessages.value.length,
    async (newLength) => {

        // 只在消息数量为 1 且还没检查过时执行
        if (newLength === 1) {

            // 等待一下，确保消息已完全渲染
            await nextTick()

            const firstMessage = currentMessages.value[0]

            if (!firstMessage) return

            // 检查是否开启了全局翻译（优先检查全局状态，再检查数字人特有状态）
            const isGlobalTranslationEnabled =
                chatStore.autoTranslate ||
                chatStore.currentDigitalHuman?.isGlobalTranslationEnabled ||
                false

            // 如果开启了全局翻译，且该消息还未被翻译，则自动翻译
            if (isGlobalTranslationEnabled && !firstMessage.translated && firstMessage.type === 'ai') {
                // 延迟执行翻译，确保页面已完全加载
                setTimeout(() => {
                    handleTranslate(firstMessage.content, firstMessage, false)
                }, 500)
            }
        }
    },
    { immediate: true } // 立即执行一次
);


// 路由离开时清空输入框
onBeforeRouteLeave(async () => {
    chatStore.setCurrentMessage('');
});

// 组件卸载时移除监听
onUnmounted(() => {
    // 清空输入框内容
    chatStore.setCurrentMessage('');

    if (messageContainer.value) {
        messageContainer.value.removeEventListener("scroll", handleScroll);
    }

    // 清理 ResizeObserver
    if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
    }

    // 清理所有 composables
    messagePopover.unregisterGlobalListeners();
    imageProgress.cleanup();
    thinkingState.cleanup();
});

// 暴露方法给父组件
defineExpose({
    scrollToBottom,
    scrollToBottomInstant
});


window.addEventListener('paymentResult', function (event: any) {
    const result = typeof event.detail === 'string' ? JSON.parse(event.detail) : event.detail
    if (result) {
        if (result.status === "success") {
            showPopupFirstCharge.value = false
        }
    }
});
</script>

<style lang="scss" scoped>
.message-center-content {
    color: #fff;
    position: relative; // 让绝对定位的 Popover 以列表为参照
    overscroll-behavior: contain;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    overflow-x: hidden;

    // 自定义滚动条
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: #262a41;
        border-radius: 3px;

        &:hover {
            background: #3a3f5c;
        }
    }
}

// 空状态样式
.empty-state {
    .suggestion-item {
        transition: all 0.2s ease;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(90, 104, 255, 0.2);
        }
    }
}

// 消息气泡样式
.message-bubble {
    border-radius: 10px;
    opacity: 0.9;
    word-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;

    // 打字动画
    &.typing-animation {
        position: relative;

        // &::after {
        //   content: "";
        //   display: inline-block;
        //   width: 3px;
        //   height: 14px;
        //   background: #a0c3ff;
        //   margin-left: 2px;
        //   animation: blink 1s infinite;
        // }
    }
}

// 打字点动画
.typing-dots {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 15px;
    height: 40px;
    justify-content: center;
    background: rgba(1, 3, 27, 0.8);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    span {
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 50%;
        animation: typing 1.4s infinite ease-in-out both;

        &:nth-child(1) {
            animation-delay: -0.32s;
        }

        &:nth-child(2) {
            animation-delay: -0.16s;
        }
    }

    border-radius: 10px;
}

// 加载动画
.loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #262a41;
    border-top: 2px solid #a0c3ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

// 消息项动画
.message-center-content-item {
    // animation: fadeInUp 0.3s ease-out;
    touch-action: pan-y;

    /* 只允许纵向滚动 */
    .ai-message {
        animation: fadeInUp 0.3s ease-out;
    }
}

.active-within {
    background: rgba(1, 3, 27, 0.3) !important;
}

// 输入框样式
:deep(.message-center-footer-input) {
    border-radius: 23px;
    // background: ;
    background: rgba(1, 3, 27, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: all 0.2s ease;
    padding: 8px 13px;
    // padding-right: 0;
    border: 1px solid rgba(255, 255, 255, 0.3);


    .message-center-footer-input-textarea {

        display: block;
        width: 100%;
        min-height: 22.5px;
        max-height: 100px;
        height: 22.5px;
        margin-left: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 1.4;
        flex: 1;
        resize: none;
        overflow-y: hidden;
        white-space: pre-wrap;
        word-break: break-word;
    }
}

// 发送按钮样式
.message-center-footer-input-send {
    margin-left: 12px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover:not(.opacity-50) {
        background: rgba(90, 104, 255, 0.1);
        transform: scale(1.05);
    }

    &:active:not(.opacity-50) {
        transform: scale(0.95);
    }
}

// 用户头像样式
.user-message .avatar {
    background: linear-gradient(135deg, #5a68ff 0%, #95a5ff 100%);
}

// 时间戳样式
.timestamp {
    font-size: 10px;
    // opacity: 0.7;
}

// 加载更多指示器样式
.load-more-indicator {
    .loading-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid #262a41;
        border-top: 2px solid #a0c3ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
}

.no-more-indicator {
    opacity: 0.7;
}

// 动画定义
@keyframes blink {

    0%,
    50% {
        opacity: 1;
    }

    51%,
    100% {
        opacity: 0;
    }
}

@keyframes typing {

    0%,
    80%,
    100% {
        transform: scale(0);
        opacity: 0.5;
    }

    40% {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 心形图标动画：淡入淡出 + 向上飘浮
.heart-animation {
    animation: heartFadeMove 2.5s cubic-bezier(0.33, 1, 0.68, 1);
    filter: drop-shadow(0 2px 8px rgba(255, 182, 193, 0.5));
}

@keyframes heartFadeMove {
    0% {
        opacity: 0;
        transform: translateY(0) scale(0.8);
        filter: brightness(1);
    }

    12% {
        opacity: 1;
        transform: translateY(-8px) scale(1.05);
        filter: brightness(1.2);
    }

    100% {
        opacity: 0;
        transform: translateY(-45px) scale(0.85);
        filter: brightness(0.8);
    }
}

// "Change scene" 提示的戳一戳动画
.shake-fade-enter-active {
    animation: pokeAnimation 0.8s cubic-bezier(0.36, 0, 0.66, -0.56);
}

.shake-fade-leave-active {
    animation: pokeFadeOut 0.3s ease-in;
}

@keyframes pokeAnimation {
    0% {
        opacity: 0;
        transform: scale(0.3) rotate(0deg);
    }

    10% {
        opacity: 1;
        transform: scale(1.2) rotate(-5deg);
    }

    20% {
        transform: scale(0.9) rotate(5deg);
    }

    30% {
        transform: scale(1.1) rotate(-4deg);
    }

    40% {
        transform: scale(0.95) rotate(4deg);
    }

    50% {
        transform: scale(1.05) rotate(-3deg);
    }

    60% {
        transform: scale(0.98) rotate(3deg);
    }

    70% {
        transform: scale(1.02) rotate(-2deg);
    }

    80% {
        transform: scale(0.99) rotate(2deg);
    }

    90% {
        transform: scale(1.01) rotate(-1deg);
    }

    100% {
        opacity: 1;
        transform: scale(1) rotate(0deg);
    }
}

@keyframes pokeFadeOut {
    0% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }

    100% {
        opacity: 0;
        transform: scale(0.8) translateY(-10px);
    }
}

:deep(.el-textarea) {
    padding: 0 !important;
    color: #fff;
    opacity: 0.5;
    font-weight: 500;
    font-size: 14px;
}

.message-content-html-wrapper {
    display: block;
    width: 100%;

    &.has-typing-indicator {
        // 让整个容器变成 inline-block，这样打字动画可以跟在后面
        display: inline-block;

        .message-content-html {

            // 让最后一个块级元素变成 inline，这样打字动画可以跟在后面
            :deep(p:last-child),
            :deep(div:last-child) {
                display: inline;
                margin-bottom: 0;
            }

            // 确保最后一个 p 标签内的内容可以正常换行
            :deep(p:last-child) {
                white-space: pre-wrap;
            }
        }
    }
}

.message-content-html {
    font-size: 16px;
    /* 全局开启换行与断行，处理没有被 <p> 包裹的文本节点 */
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;

    :deep(p) {
        color: v-bind('theme.colors.textPrimary');
        white-space: pre-wrap;
        /* 保留换行 */
        word-break: break-word;
        /* 长单词断行 */
        overflow-wrap: anywhere;
        /* 连续字符换行 */
        margin: 0;
        /* 与 <br/> 搭配，避免额外间距 */

        font-style: italic;

    }

    img {
        max-width: 100%;
        height: auto;
        display: block;
        border-radius: 6px;
    }



    :deep(em) {
        color: v-bind('theme.colors.textPrimarySix') !important;
    }

    // 🔧 对话和旁白样式
    :deep(.dialogue) {
        // 引号内的对话 - 白色
        color: #fff;
        font-style: normal;

        em {
            color: #fff !important;
            font-style: normal;
        }
    }

    :deep(.narration) {
        // 引号外的旁白 - 灰色
        color: #999;
        opacity: 0.8;
        font-style: italic;
    }

    // 链接样式
    a {
        color: v-bind('theme.colors.primary');
        text-decoration: underline;

        &:hover {
            color: v-bind('theme.colors.primaryHover');
        }

        &:active {
            color: v-bind('theme.colors.primaryActive');
        }
    }

    // 标题样式
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: #fff;
        margin: 8px 0;
        line-height: 1.3;
    }

    // 强调/加粗

    // 行内代码
    code:not(.hljs) {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #fff;
        padding: 2px 6px;
        border-radius: 6px;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }

    // 代码块（已由 highlight.js 样式表控制，这里微调暗色背景适配）
    pre.hljs {
        background: transparent !important;
        border-radius: 10px;
        padding: 12px;
        overflow-x: auto;
        white-space: pre-wrap; // 允许换行并保留缩进
        word-break: break-word; // 遇到长单词或长链接也换行
        overflow-wrap: anywhere; // 进一步保证超长连续字符可换行
    }

    // 使内部 code 继承换行策略
    pre.hljs code {
        white-space: inherit;
        word-break: inherit;
        overflow-wrap: inherit;
        max-width: 100%;
        display: block;
    }

    // 引用
    blockquote {
        border-left: 3px solid v-bind('theme.colors.primary');
        margin: 8px 0;
        padding: 6px 10px;
        background: rgba(255, 255, 255, 0.04);
        color: v-bind('theme.colors.textSecondary');
        border-radius: 6px;
    }

    // 列表
    ul li,
    ol li {
        color: v-bind('theme.colors.textPrimary');
        margin: 4px 0;
    }
}

.ai-message-content-translate {
    background: rgba(255, 255, 255, 0.1);
    color: v-bind('theme.colors.textPrimary');
}

.ai-message-content {
    background: rgba(1, 3, 27, 0.8);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.intro-text-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}

.color-bg {
    background: rgba(1, 3, 27, 0.5);

}

:deep(.van-popover__wrapper) {
    display: inline !important;
}

// 回到底部按钮样式
.scroll-to-bottom {
    position: fixed;
    right: 20px;
    bottom: 150px;
    width: 44px;
    height: 44px;
    border-radius: 22px;
    background: v-bind('theme.colors.backgroundSecondary');
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
}

// 渐入渐出动画
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.content-color {
    em {
        color: v-bind('theme.colors.textPrimarySix') !important;
    }
}

.thinking-box {
    width: 200px;
    //   background: #000;
    //   color: #0f0;
    font-size: 13px;
    line-height: 15px;
}

/* 内容向上滚动动画 */
.thinking-content {
    display: flex;
    flex-direction: column;
    animation: scroll-up 0.1s linear infinite;
}

/* 动画定义 */
@keyframes scroll-up {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(-100%);
    }
}

.animate-pulse {
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }
}

/* Thinking 文字滚动显示最新内容 - 单行向下滚动 */
.thinking-text-scroll {
    overflow-x: hidden;
    overflow-y: hidden;
    text-overflow: ellipsis;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
}

/* 只有在更新时才启用向下滚动 */
.thinking-text-scroll.is-updating {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
    text-overflow: clip;
    white-space: normal;
    height: 18px;
    /* 固定高度为一行，内容可以多行但只显示一行 */
}

.thinking-text-scroll.is-updating::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

.thinking-text-inner {
    color: v-bind('theme.colors.textPrimary');
    display: block;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
    line-height: 18px;
    /* 内容可以多行，但容器只显示一行，新内容在底部 */
}

.thinking-text-inner-content {
    color: v-bind('theme.colors.textPrimary');
}

.animate-bounce-dot {
    display: inline-block;
    animation: bounce-dot 1.4s ease-in-out infinite;
}

.dot-1 {
    animation-delay: 0s;
}

.dot-2 {
    animation-delay: 0.2s;
}

.dot-3 {
    animation-delay: 0.4s;
}

// 🔧 新增：打字指示器样式
.typing-indicator {
    color: #EDF4FF;
    font-size: 16px;
    line-height: 1.5;
    vertical-align: baseline;
    opacity: 0.7;
    display: inline;
    margin-left: 2px;
    white-space: nowrap;

    span {
        display: inline-block;
    }
}

@keyframes bounce-dot {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-6px);
    }
}


.message-active-bottom {
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 85%, rgba(0, 0, 0, 1) 100%);

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100px;
    // background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);
    // border-radius: 10px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.rawImage {
    border-radius: 15px;
    padding: 5px 6px;
    background: rgba(1, 3, 27, 0.8);
    color: v-bind('theme.colors.textPrimary');

    .free {
        background: linear-gradient(90deg, #A06EFA 0%, #FA6CCE 100%);
        box-shadow: inset 0px 0px 10px 0px rgba(112, 57, 203, 0.5);
        border-radius: 15px;
        font-size: 10px;
        color: #FFFFFF;
        padding: 2px 5px;
    }
}

.image-position {
    margin-top: 20px;
    width: 120px;
    height: 160px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;

    .images-error {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        // opacity: 0.5;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
    }

    .failed-message {
        background: rgba(239, 62, 62, 0.3);
    }
}

.image-loaded {
    width: 100%;
    height: 100%;
    position: relative;
    transition: opacity 0.3s ease;

    &.image-hidden {
        opacity: 0;
        pointer-events: none;
    }
}

.skeleton-image {
    width: 100%;
    height: 100%;
    // background: rgba(40, 30, 55, 0.8);
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    &.skeleton-overlay {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        transition: opacity 0.3s ease;
    }
}

.skeleton-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 12px;

    .loading-spinner {
        width: 32px;
        height: 32px;
        border: 3px solid rgba(160, 110, 250, 0.2);
        border-top: 3px solid rgba(160, 110, 250, 0.8);
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    .loading-percentage {
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }
}

// .skeleton-shimmer {
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg,
//             transparent,
//             rgba(160, 110, 250, 0.3),
//             transparent);
//     animation: skeleton-shimmer 1.5s ease-in-out infinite;
// }

@keyframes skeleton-shimmer {
    0% {
        left: -100%;
    }

    100% {
        left: 100%;
    }
}

.msg-img-cost {
    width: 32px;
    height: 16px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    font-weight: 500;
    font-size: 10px;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 9px;
}

// 🔧 心跳动画
.heartbeat-animation {
    animation: heartbeat 1s ease-in-out;
}

@keyframes heartbeat {
    0% {
        transform: scale(1);
    }

    14% {
        transform: scale(1.3);
    }

    28% {
        transform: scale(1);
    }

    42% {
        transform: scale(1.3);
    }

    70% {
        transform: scale(1);
    }
}

.reload-message-content {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>